import React from "react";
import { useTheme } from "@mui/material";
import ChatShell from "../bot/ChatShell";

function Home() {
    const theme = useTheme();

    const root = document.documentElement;
    const isDarkTheme = theme.palette.mode === 'dark';

    if (isDarkTheme) {
        root.style.setProperty('--scrollbar-thumb-color', '#4A4A4A');
        root.style.setProperty('--scrollbar-thumb-hover-color', '#6C6C6C');
        root.style.setProperty('--scrollbar-thumb-active-color', '#909090');
        root.style.setProperty('--scrollbar-track-color', '#333333');
    } else {
        root.style.setProperty('--scrollbar-thumb-color', '#B0B0B0');
        root.style.setProperty('--scrollbar-thumb-hover-color', '#959595');
        root.style.setProperty('--scrollbar-thumb-active-color', '#7A7A7A');
        root.style.setProperty('--scrollbar-track-color', '#E0E0E0');
    }

    return <ChatShell />;
}

export default Home;